(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-hub"] && !Shopify.designMode) return;
  try {
    if(location.pathname==='/'&&['#calculator','#guide','#planner'].includes(location.hash)){location.replace('/pages/promotion-profit-calculator'+location.search+location.hash);}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-investment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cw-investment')) {
  window.cwInvestmentProject = function(start, monthly, rate, years) {
    if (![start, monthly, rate, years].every(Number.isFinite) || start < 0 || monthly < 0 || rate <= -100 || !Number.isInteger(years) || years < 0 || years > 50) return null;
    const factor = Math.pow(1 + rate / 100, 1 / 12);
    let balance = start;
    const rows = [{year: 0, invested: start, growth: 0, balance: start}];
    for (let month = 1; month <= years * 12; month++) {
      balance = balance * factor + monthly;
      if (!Number.isFinite(balance) || balance > Number.MAX_SAFE_INTEGER / 100) return null;
      if (month % 12 === 0) {
        const invested = start + monthly * month;
        rows.push({year: month / 12, invested, growth: balance - invested, balance});
      }
    }
    return {rows, ...rows[rows.length - 1]};
  };
  class CWInvestment extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.form = this.querySelector('form');
      this.words = JSON.parse(this.querySelector('[data-words]').textContent);
      this.extra = 0;
      this.addEventListener('cw-currency-change',()=>this.update());
      this.form.addEventListener('submit', event => {event.preventDefault(); this.update();});
      this.form.addEventListener('input', event => {
        if (event.target.name === 'monthly') this.extra = 0;
        this.syncOptions(); this.update();
      });
      this.querySelector('[data-reset]').addEventListener('click', () => {const currency=this.querySelector('[data-currency]').value;this.form.reset();this.querySelector('[data-currency]').value=currency; this.extra = 0; this.syncOptions(); this.update();});
      this.querySelectorAll('[data-extra]').forEach(button => button.addEventListener('click', () => {this.extra = Number(button.dataset.extra); this.update();}));
      this.syncOptions(); this.update();
    }
    syncOptions() {
      const on = this.form.elements.inflationOn.checked;
      this.querySelector('[data-inflation-fields]').hidden = !on;
      this.form.elements.inflation.disabled = !on;
    }
    money(n) {return new Intl.NumberFormat(navigator.languages, {style:'currency', currency:this.querySelector('[data-currency]')?.value||'AUD', currencyDisplay:'code', maximumFractionDigits:0, minimumFractionDigits:0}).format(Math.abs(n) < .005 ? 0 : n);}
    phrase(key, args) {return Object.entries(args).reduce((s,[k,v]) => s.replaceAll('{'+k+'}',v),this.words[key]);}
    text(selector, value) {this.querySelector(selector).textContent = value;}
    fail(message) {this.text('[data-error]',message);this.querySelector('[data-error]').hidden=false;this.querySelector('[data-results]').hidden=true;}
    update() {
      if (!this.form.checkValidity()) {this.fail(this.words.invalid);return;}
      const el = this.form.elements;
      const start = el.start.valueAsNumber, base = el.monthly.valueAsNumber, monthly = base + this.extra, rate = el.rate.valueAsNumber, years = el.years.valueAsNumber;
      const r = window.cwInvestmentProject(start,monthly,rate,years);
      if (!r) {this.fail(this.words.overflow);return;}
      this.querySelector('[data-error]').hidden=true;
      this.querySelector('[data-results]').hidden=false;
      this.text('[data-final]',this.money(r.balance));this.text('[data-invested]',this.money(r.invested));this.text('[data-growth]',this.money(r.growth));
      this.text('[data-summary]',this.phrase('summary',{years,monthly:this.money(monthly),rate}));
      this.querySelector('[data-real]').hidden=!el.inflationOn.checked;
      if(el.inflationOn.checked) this.text('[data-real]',this.phrase('real',{amount:this.money(r.balance/Math.pow(1+el.inflation.valueAsNumber/100,years)),inflation:el.inflation.value}));
      this.querySelector('[data-goal]').hidden=el.goal.value==='';
      if(el.goal.value!=='') {
        const delta=r.balance-el.goal.valueAsNumber;
        this.text('[data-goal]',this.phrase(Math.abs(delta)<.005?'goal_equal':delta>0?'goal_met':'goal_short',{amount:this.money(Math.abs(delta))}));
      }
      this.querySelectorAll('[data-extra]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.extra)===this.extra)));
      this.text('[data-extra-summary]',this.phrase(this.extra?'extra_summary':'base_summary',{monthly:this.money(monthly),base:this.money(base),extra:this.money(this.extra)}));
      const tbody=this.querySelector('[data-annual]');tbody.replaceChildren();
      r.rows.forEach(row=>{const tr=document.createElement('tr');['year','invested','growth','balance'].forEach(key=>{const cell=document.createElement(key==='year'?'th':'td');if(key==='year')cell.scope='row';cell.textContent=key==='year'?row[key]:this.money(row[key]);tr.appendChild(cell);});tbody.appendChild(tr);});
      this.chart(r.rows);
    }
    chart(rows) {
      const group=this.querySelector('[data-chart]');group.replaceChildren();
      const add=(tag,attrs,text)=>{const n=document.createElementNS('http://www.w3.org/2000/svg',tag);Object.entries(attrs).forEach(([k,v])=>n.setAttribute(k,v));if(text!==undefined)n.textContent=text;group.appendChild(n);return n;};
      const max=Math.max(1,...rows.map(r=>Math.max(r.balance,r.invested))), min=Math.min(0,...rows.map(r=>r.growth));
      const top=18,bottom=264,left=78,right=586, span=max-min;
      const font = window.innerWidth < 600 ? 17 : 13;
      const y=v=>bottom-(v-min)/span*(bottom-top),zero=y(0);
      for(let i=0;i<=4;i++) {
        const v=min+span*i/4,yy=y(v);
        add('line',{x1:left,x2:right,y1:yy,y2:yy,stroke:'#dbe2e8'});
        const label=new Intl.NumberFormat('en-AU',{notation:'compact',maximumFractionDigits:1}).format(v);
        add('text',{x:left-10,y:yy+4,'text-anchor':'end',fill:'#526570','font-size':font},label);
      }
      add('line',{x1:left,x2:right,y1:zero,y2:zero,stroke:'#7c8e9c','stroke-width':1.2});
      const step=(right-left)/rows.length,w=Math.max(2,step*.66),tick=Math.max(1,Math.ceil((rows.length-1)/5));
      rows.forEach((r,i)=>{
        const x=left+step*i+(step-w)/2;
        add('rect',{x,y:y(r.invested),width:w,height:Math.max(0,zero-y(r.invested)),fill:'#c5a874'});
        if(r.growth>=0) add('rect',{x,y:y(r.balance),width:w,height:Math.max(0,y(r.invested)-y(r.balance)),fill:'#162d43'});
        else add('rect',{x,y:zero,width:w,height:Math.max(0,y(r.growth)-zero),fill:'#162d43'});
        if(i%tick===0||i===rows.length-1)add('text',{x:x+w/2,y:290,'text-anchor':'middle',fill:'#526570','font-size':font},r.year);
      });
      add('text',{x:332,y:315,'text-anchor':'middle',fill:'#526570','font-size':font},this.words.year+' · '+(this.querySelector('[data-currency]')?.value||'AUD'));
      this.querySelector('[data-loss-note]').hidden=min>=-.005;
    }
  }
  customElements.define('cw-investment',CWInvestment);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["margin-home"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('margin-calculator')) {
class MarginCalculator extends HTMLElement {
connectedCallback() {
if(this.ready)return; this.ready=true;
this.form=this.querySelector('form');this.words=JSON.parse(this.querySelector('[data-words]').textContent);
this.addEventListener('cw-currency-change',()=>this.update());
this.form.addEventListener('submit',e=>{e.preventDefault();this.update();});
this.form.addEventListener('input',()=>this.update());
this.querySelector('[data-reset]').addEventListener('click',()=>{const currency=this.querySelector('[data-currency]').value;this.form.reset();this.querySelector('[data-currency]').value=currency;this.update();});this.update();
}
update(){
const values={};for(const input of this.form.querySelectorAll('input')){if(input.value.trim()===''||!input.validity.valid){this.showError(this.words.invalid);return;}values[input.name]=Number(input.value);}
const {price:p,cost:c,orders:n,discount:d,increase:g}=values;
const r=window.marginCalculate(p,c,n,d,g);
if(!r){this.showError(this.words.invalid);return;}
this.querySelector('[data-error]').hidden=true;this.querySelector('[data-results]').hidden=false;
const money=v=>new Intl.NumberFormat(navigator.languages,{style:'currency',currency:this.querySelector('[data-currency]')?.value||'AUD',currencyDisplay:'code'}).format(v);
this.drawProfit(r,money);
const count=v=>new Intl.NumberFormat('en-AU').format(v);
const normal={sale_price:p,cost_order:c,contribution:r.b,volume:n,revenue:p*n,total:r.bt};
const promo={sale_price:r.pd,cost_order:c,contribution:r.a,volume:r.np,revenue:r.pd*r.np,total:r.at};
for(const [kind,obj] of Object.entries({normal,promo}))for(const [key,val]of Object.entries(obj))this.querySelector('[data-'+kind+'="'+key+'"]').textContent=key==='volume'?count(val):money(val);
this.querySelector('[data-delta]').textContent=(r.delta>0?'+':'')+money(r.delta);
const state=r.delta>0.005?'ahead':r.delta<-.005?'behind':'same';
this.querySelector('[data-verdict]').textContent=this.words[state].replace('{amount}',money(Math.abs(r.delta)));
this.querySelector('[data-summary]').dataset.state=state;
const warn=this.querySelector('[data-warning]');warn.hidden=r.b>0&&r.a>0;
warn.textContent=r.b<=0?this.words.baseline_warning:this.words.loss_warning;
for(const key of ['required','extra','uplift'])this.querySelector('[data-'+key+']').textContent=r.required===null?(r.b<=0?this.words.na:this.words.impossible):(key==='required'?count(r.required):key==='extra'?count(Math.max(0,r.required-n)):(Math.max(0,(r.required/n-1)*100)).toFixed(1)+'%');
}
drawProfit(r,money){
const group=this.querySelector('[data-profit-bars]');if(!group)return;group.replaceChildren();
const add=(tag,attrs,text)=>{const el=document.createElementNS('http://www.w3.org/2000/svg',tag);for(const [k,v]of Object.entries(attrs))el.setAttribute(k,v);if(text!==undefined)el.textContent=text;group.appendChild(el);};
const min=Math.min(0,r.bt,r.at),max=Math.max(0,r.bt,r.at),span=max-min||1,x=v=>16+(v-min)/span*568,zero=x(0);
add('line',{x1:zero,x2:zero,y1:39,y2:198,stroke:'#718391','stroke-width':1.5});
[[this.words.usual,r.bt,'#c5a874'],[this.words.promotion,r.at,'#162d43']].forEach(([label,value,fill],i)=>{const y=28+i*95;add('text',{x:16,y,fill:'#162d43','font-size':18},label);add('text',{x:584,y,'text-anchor':'end',fill:'#162d43','font-size':18,'font-weight':650},money(value));add('rect',{x:Math.min(zero,x(value)),y:y+14,width:Math.abs(x(value)-zero),height:42,fill,rx:3});});
add('text',{x:zero,y:226,'text-anchor':zero<40?'start':zero>560?'end':'middle',fill:'#526570','font-size':16},this.words.zero);
this.querySelector('[data-profit-description]').textContent=this.words.usual+': '+money(r.bt)+'. '+this.words.promotion+': '+money(r.at)+'.';
}
showError(message){const el=this.querySelector('[data-error]');el.textContent=message;el.hidden=false;this.querySelector('[data-results]').hidden=true;}
}
window.marginCalculate=function(p,c,n,d,g){
if(![p,c,n,d,g].every(Number.isFinite)||p<0||c<0||n<=0||!Number.isInteger(n)||d<0||d>100||g< -100)return null;
const pd=p*(1-d/100),b=p-c,a=pd-c,np=Math.round(n*(1+g/100)),bt=b*n,at=a*np;
if(![pd,b,a,np,bt,at,at-bt].every(Number.isFinite)||!Number.isSafeInteger(np))return null;
let required=b>0&&a>0?Math.ceil(bt/a-1e-10):null;
if(required!==null&&!Number.isSafeInteger(required))required=null;
return {pd,b,a,np,bt,at,delta:at-bt,required};
};
customElements.define('margin-calculator',MarginCalculator);
}
  } catch(e) { console.error(e); }
})();
})();
